import request from 'network/request';

export function getGoodsDetail(params) {
  return request({
    url: '/order/goods/detail/po',
    method: 'get',
    params
  });
}
